import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import FooterStore from '@src/business-components/footer/store';
import { getParameterByNames } from '@src/utils/device';
class FocusUsSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;

  // 底部
  footerStore = new FooterStore({});

  @observable isActive = false;

  // 关注列表
  focusList = [
    {
      name: 'B站',
      url: 'https://space.bilibili.com/1409863611?spm_id_from=333.337.0.0',
      image: require('./images/bilibili.png')
    },
    {
      name: 'TapTap',
      url: 'https://www.taptap.cn/app/222089',
      image: require('./images/taptap.png')
    },
    {
      name: '微博',
      url: 'https://weibo.com/u/7573935610',
      image: require('./images/weibo.png')
    },
    {
      name: '微信',
      url: '',
      image: require('./images/weixin.png')
    },
    {
      name: 'QQ群',
      url:
        'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=ESU7Uxq81QGXTsP3h-nIK0-PmckarYBc&authKey=6k8kE4yEbAa2QLwbjqIZiafUue4S28ujhJDro1TAKuZw0WRCbdR5HK0%2B3hyGZyyo&noverify=0&group_code=868421507',
      image: require('./images/qq.png')
    },
    {
      name: '好游快爆',
      url: 'https://www.3839.com/a/137270.htm',
      image: require('./images/haoyoukuaibao.png')
    }
  ];

  use() {
    super.use();
    useMount(() => {
      this.footerStore.utmSource = getParameterByNames('utm_source');
    });
    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 6;
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default FocusUsSectionStore;
